import React from "react";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import {
  WebsiteAudit,
  useWebsiteAudit,
} from "../../components/organisms/website-audit/WebsiteAudit";
import { PageHeader } from "../../components/layout/header/Header";

const Header: React.FC = () => (
  <PageHeader
    titleContent="Website Audit"
    descriptionContent={<>We’ll scan your site to ensure all required links are present.</>}
  />
);

export const WebsiteAuditPage = () => {
  const websiteAudit = useWebsiteAudit();

  // Page Content
  return (
    <StandardPageWrapper requests={Object.values(websiteAudit.requests)}>
      <Header />

      <WebsiteAudit
        {...websiteAudit.props}
        onRescan={() => {
          websiteAudit.refreshSurvey();
        }}
        inSurvey={false}
      />
    </StandardPageWrapper>
  );
};
